// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/groupIcons.template file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const AppstoreDe = svgLazyLoader('store/appstore_de')
const AppstoreEn = svgLazyLoader('store/appstore_en')
const AppstoreEs = svgLazyLoader('store/appstore_es')
const AppstoreFr = svgLazyLoader('store/appstore_fr')
const AppstoreIt = svgLazyLoader('store/appstore_it')
const GoogleplayDe = svgLazyLoader('store/googleplay_de')
const GoogleplayEn = svgLazyLoader('store/googleplay_en')
const GoogleplayEs = svgLazyLoader('store/googleplay_es')
const GoogleplayFr = svgLazyLoader('store/googleplay_fr')
const GoogleplayIt = svgLazyLoader('store/googleplay_it')

const ALL_STORE_ICONS = [
  'appstore_de',
  'appstore_en',
  'appstore_es',
  'appstore_fr',
  'appstore_it',
  'googleplay_de',
  'googleplay_en',
  'googleplay_es',
  'googleplay_fr',
  'googleplay_it',
] as const
export type StoreIcon = (typeof ALL_STORE_ICONS)[number]

const ICONS: LazyIconsGroup<StoreIcon> = {
  appstore_de: AppstoreDe,
  appstore_en: AppstoreEn,
  appstore_es: AppstoreEs,
  appstore_fr: AppstoreFr,
  appstore_it: AppstoreIt,
  googleplay_de: GoogleplayDe,
  googleplay_en: GoogleplayEn,
  googleplay_es: GoogleplayEs,
  googleplay_fr: GoogleplayFr,
  googleplay_it: GoogleplayIt,
}

export const isStoreIcon = (storeKey: string): storeKey is StoreIcon => ALL_STORE_ICONS.includes(storeKey as StoreIcon)

export const getStoreIcon = (storeKey: StoreIcon): LazyIcon => ICONS[storeKey]

export const getStoreIcons = (): LazyIconsGroup<StoreIcon> => ICONS
